<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        @if (data.folders.length === 1) {
            <mat-card-title>Suppression de dossier</mat-card-title>
        } @else if (data.folders.length > 1) {
            <mat-card-title>Suppression de dossiers</mat-card-title>
        }
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            @if (data.folders.length === 1) {
                <!-- Affichage en cas de suppression d'un dossier unique -->
                <p class="text">ATTENTION! Vous êtes sur le point de supprimer le dossier '{{ data.folders[0].name }}'.</p>
                <p class="text">Confirmez-vous la suppression de ce dossier ?</p>
                <mat-checkbox class="accept-mat-checkbox primary-button" [formControl]="confirmFormControl">
                    <span class="mat-checkbox-text primary-button">Je confirme la suppression du dossier.</span>
                </mat-checkbox>
            } @else if (data.folders.length > 1) {
                <!-- Affichage en cas de suppression de plusieurs dossiers -->
                <p class="text">ATTENTION! Vous êtes sur le point de supprimer {{ data.folders.length }} dossiers.</p>
                <p class="text">Confirmez-vous la suppression des dossiers suivants?</p>
                <ul class="foldersList">
                    @for (folder of data.folders; track folder.id) {
                        <li>
                            {{ folder.name }}
                        </li>
                    }
                </ul>
                <mat-checkbox class="accept-mat-checkbox primary-button" [formControl]="confirmFormControl">
                    <span class="mat-checkbox-text">Je confirme la suppression des dossiers.</span>
                </mat-checkbox>
            }
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [mat-dialog-close]="false">Annuler</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="true" [disabled]="!confirmFormControl.value">Valider</button>
    </mat-card-actions>
</mat-card>
